import React from "react";
import {Button, Table} from "react-bootstrap";
import ModalTable from "./ModalTable";

const UnknownLabel = "Не определено";

class StatisticTable extends React.Component {
	state = {
		showFullTable: false
	};

	constructor(props) {
		super(props);

		this.handleToggleFullTable = this.handleToggleFullTable.bind(this);
		this.showFullTable = this.showFullTable.bind(this);
		this.hideFullTable = this.hideFullTable.bind(this);
	}

	showFullTable() {
		this.setState({showFullTable: true});
	}
	hideFullTable() {
		this.setState({showFullTable: false});
	}

	handleToggleFullTable() {
		this.setState({showFullTable: !this.state.showFullTable});
	}

	render() {
		const tableDataLimit = 5;
		const props = this.props;
		const data = props.data;
		const hasHiddenTableData = data.length > tableDataLimit;
		const tableData = data.slice(0, tableDataLimit);
		if(data.length > tableDataLimit) {
			tableData.push({
				name: 'Остальные',
				count: data.slice(tableDataLimit).reduce((last, cur) => last + parseInt(cur.count), 0)
			})
		}

		return (
			<section>
				<Table responsive>
					<colgroup>
						<col />
						<col width="80"/>
					</colgroup>
					<thead>
					<tr>
						{this.props.titles.map((title, index) => <th key={index}>{title}</th>)}
					</tr>
					</thead>
					<tbody>
					{tableData.map((item, index) =>
						<tr key={index}>
							<td>{item.name || UnknownLabel}</td>
							<td>{item.count}</td>
						</tr>
					)}
					{hasHiddenTableData && <tr>
						<td colSpan="2" style={{textAlign: 'right'}}>
							<Button onClick={this.handleToggleFullTable}>Показать все</Button>
						</td>
					</tr>}
					</tbody>
				</Table>
				<ModalTable show={this.state.showFullTable} onHide={this.hideFullTable} {...props} />
			</section>
		);
	}
}

export default StatisticTable;
